const entitySelect =
  'id,name,isActive,isPremium,authorityUrl,resourceUrl,apiUrl,embedUrlBase,redirectUrl,username,password,clientId,clientSecret';

export default {
  paged: {
    select: 'id,name,isActive,isPremium',
    searchSelect: ['name'],
    orderBy: 'name',
  },
  item: {
    select: entitySelect,
  },
  itemDetail: {
    select: `${entitySelect},created,updated`,
    expand: {
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
